import script from "./SummaryTableEmployeeRowView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryTableEmployeeRowView.vue?vue&type=script&lang=ts&setup=true"

import "./SummaryTableEmployeeRowView.vue?vue&type=style&index=0&id=23d4dc52&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d4dc52"]])

export default __exports__